module.exports = __webpack_public_path__ + "static/img/Hussar_score_face.320c3ac.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/Hussar_score_face.webp
// module id = s3n5
// module chunks = 0